// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.dropdown-menu {
  display: none;
}

.dropdown-menu.show {
  display: flex ;
}

.tab-content .tab-pane {
  display: none;
}

.tab-content .tab-pane.active.show {
  display: flex;
}


.icons{
  max-height: 350px;

}


.search{
  top: 4.5%;
  left: 91%;

}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb25zLXNlbGVjdG9yLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtFQUNFLGFBQWE7QUFDZjs7QUFFQTtFQUNFLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxhQUFhO0FBQ2Y7O0FBRUE7RUFDRSxhQUFhO0FBQ2Y7OztBQUdBO0VBQ0UsaUJBQWlCOztBQUVuQjs7O0FBR0E7RUFDRSxTQUFTO0VBQ1QsU0FBUzs7QUFFWCIsImZpbGUiOiJpY29ucy1zZWxlY3Rvci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG5cbi5kcm9wZG93bi1tZW51IHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLmRyb3Bkb3duLW1lbnUuc2hvdyB7XG4gIGRpc3BsYXk6IGZsZXggO1xufVxuXG4udGFiLWNvbnRlbnQgLnRhYi1wYW5lIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLnRhYi1jb250ZW50IC50YWItcGFuZS5hY3RpdmUuc2hvdyB7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG5cblxuLmljb25ze1xuICBtYXgtaGVpZ2h0OiAzNTBweDtcblxufVxuXG5cbi5zZWFyY2h7XG4gIHRvcDogNC41JTtcbiAgbGVmdDogOTElO1xuXG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/icons-selector/icons-selector.component.css"],"names":[],"mappings":";;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,iBAAiB;;AAEnB;;;AAGA;EACE,SAAS;EACT,SAAS;;AAEX;;AAEA,gzBAAgzB","sourcesContent":["\n\n.dropdown-menu {\n  display: none;\n}\n\n.dropdown-menu.show {\n  display: flex ;\n}\n\n.tab-content .tab-pane {\n  display: none;\n}\n\n.tab-content .tab-pane.active.show {\n  display: flex;\n}\n\n\n.icons{\n  max-height: 350px;\n\n}\n\n\n.search{\n  top: 4.5%;\n  left: 91%;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
